export default "__VITE_PUBLIC_ASSET__3415d079__"